import {Component, ElementRef, inject, ViewChild} from '@angular/core';
import {PartnersStore} from "./store/partners-store";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  imports: [
    MatTooltip
  ],
  styleUrls: ['./partners.component.scss'],
  providers: [PartnersStore],
})
export class PartnersComponent {

  @ViewChild('sectionElement') servicesElement!: ElementRef;
  readonly #store: any = inject(PartnersStore);

  protected readonly partners = this.#store.partners;

  openLink(url: string) {
    window.open(url, '_blank');
  }

  protected reload(): void {
    this.#store.reload();
  }
}
